import { render } from "./ModalProgetto.vue?vue&type=template&id=c5c93d64&ts=true"
import script from "./ModalProgetto.vue?vue&type=script&lang=ts"
export * from "./ModalProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__